import type { OrderStatusSchema } from '@wave/shared';

const LABELS: Record<OrderStatusSchema, string> = {
  new: 'Новая',
  progress: 'В работе',
  closed: 'Закрыта',
  reject: 'Реджект',
  deleted: 'Удалена',
};

export function StatusBadge({ status }: { status: OrderStatusSchema }) {
  return <span className={`badge badge-${status}`}>{LABELS[status]}</span>;
}
